<template>
  <div id="profile-page">
    <div class="vx-row m-2">
      <div class="router-header flex flex-wrap items-center mb-6 mt-5">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">{{ $t("profile") }}</h2>
        </div>
      </div>
    </div>

    <div class="vx-row m-2">
      <div class="vx-col w-full lg:w-1/4 mb-base">
        <vx-card :title="$t('profile')" class="mt-base pt-5 pb-5">
          <!-- ACTION SLOT -->
          <template slot="actions">
            <feather-icon icon="MoreHorizontalIcon"></feather-icon>
          </template>

          <!-- USER BIO -->
          <div class="user-bio flex items-center center">
            <vs-avatar
              color="primary"
              size="150px"
              :text="userProfile.username"
              class="profile"
            />
          </div>

          <!-- OTEHR DATA -->
          <div class="mt-5">
            <h6>{{ $t("profilePage.joined") }}:</h6>
            <p>{{ setDateFormat(userProfile.createAt) }}</p>
          </div>

          <div class="mt-5">
            <h6>{{ $t("profilePage.email") }}:</h6>
            <p>{{ userProfile.email }}</p>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-2/3 mb-base">
        <vx-card :title="$t('information')" class="mt-base px-10 pt-5 pb-10">
          <!-- ACTION SLOT -->
          <!-- <template slot="actions">
            <feather-icon
              icon="MoreHorizontalIcon"
              @click="$router.push('/edit-profile')"
            ></feather-icon>
          </template> -->

          <!-- OTEHR DATA -->
          <div class="mt-5">
            <h6>{{ $t("profilePage.username") }}:</h6>
            <p>{{ userProfile.username }}</p>
          </div>

          <div class="mt-5">
            <h6>{{ $t("profilePage.firstName") }}:</h6>
            <p>{{ userProfile.firstName }}</p>
          </div>

          <div class="mt-5">
            <h6>{{ $t("profilePage.lastName") }}:</h6>
            <p>{{ userProfile.lastName }}</p>
          </div>

          <!-- <div class="mt-5">
            <h6>{{ $t("profilePage.dateOfBirth") }}:</h6>
            <p>{{ setDateFormat(userProfile.dayOfBirth) }}</p>
          </div> -->

          <!-- <div class="mt-5">
            <h6>{{ $t("profilePage.address") }}:</h6>
            <p>{{ userProfile.address }}</p>
          </div> -->

          <!-- <div class="mt-5">
            <h6>{{ $t("profilePage.city") }}:</h6>
            <p>{{ userProfile.city }}</p>
          </div> -->

          <!-- <div class="mt-5">
            <h6>{{ $t("profilePage.country") }}:</h6>
            <p>{{ userProfile.country }}</p>
          </div> -->

          <div class="mt-10">
            <vs-button class="mr-3 mb-2"  color="warning"  icon-pack="feather" icon="icon-edit"  @click="$router.push('/edit-profile')">แก้ไข</vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import moment from "moment";

export default {
  name: "profilePage",
  data() {
    return {
      activePassword: false,
      valMultipe: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.profile.userProfile,
    }),
  },
  watch: {
    userProfile(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
      }
    },
  },
  mounted() {
    this.getUserProfile();
  },
  methods: {
    getUserProfile() {
      const username = localStorage.getItem("accessUsername");
      this.$store.dispatch("getUserProfile", username);
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    changePassword() {
      this.activePassword = true;
    },
    acceptAlert() {},
    close() {},
  },
};
</script>
<style>
.header {
  font-size: 30px;
  font-weight: bold;
}
.center {
  justify-content: center;
}
.newpass {
  margin-left: 8px;
}
.input {
  margin: 8px;
}
</style>